import {graphql} from 'gatsby'
import BlogDetailsTemplate from './BlogDetails.template'

export const query = graphql`
  query ($id: String!) {
    blog: wpPost(
      status: {eq: "publish"},
      id: {eq: $id},
    ) {
      title
      slug
      content
      gallery {
        id
        url: sourceUrl
      }
      createdAt: date
      acf {
        thumbnail {
          url: sourceUrl
        }
      }
    }
    recentProperties: allWpProduct(
      filter: {
        status: {eq: "publish"},
      },
      sort: {fields: date, order: DESC},
      limit: 3,
    ) {
      edges {
        node {
          id,
          name: title
          slug
          acf {
            isSold: issold
            isForSale: isforsale
            isForRent: isforrent
            addressNumber: addressnumber
            street {
              ... on WpStreet {
                name: title
              }
            }
            thumbnail {
              url: sourceUrl
              alt: altText
              mediaDetails {
                width
                height
              }
            }
            price
          }
        }
      }
    }
    latestBlogList: allWpPost(
      filter: {
        status: {eq: "publish"},
      },
      sort: {fields: date, order: DESC},
      limit: 3,
    ) {
      edges {
        node {
          id
          title
          slug
          createdAt: date
          acf {
            thumbnail {
              url: sourceUrl
              alt: altText
              mediaDetails {
                width
                height
              }
            }
          }
        }
      }
    }
  }
`

export default BlogDetailsTemplate
